function officeCityStateLine(o) {
  if (!o) {
    return '';
  }
  return [o.city, o.state].filter(Boolean).join(', ');
}

function practiceDefaultCityStateLine(practice) {
  return officeCityStateLine(practice?.get('defaultOffice'));
}

function modalityLabel({ hasInPerson, hasTelehealth, intl, k }) {
  if (!hasInPerson && !hasTelehealth) {
    return intl.t(`${k}onlineOnly`);
  }
  if (hasInPerson && hasTelehealth) {
    return intl.t(`${k}hybrid`);
  }
  if (hasInPerson) {
    return intl.t(`${k}remote`);
  }
  return intl.t(`${k}virtualOnly`);
}

function isPhysicalOffice(office) {
  return office && !office.isVideo;
}

export function locationLineFor({
  dominantOffice,
  hasInPerson,
  hasTelehealth,
  selectedOffices,
  officesForCptCode,
  practice,
  intl,
}) {
  let k = 'booking.clinicianSearch.card.';
  let selectedPhysicalOffice;

  let selectedPhysicalOffices = selectedOffices?.length
    ? selectedOffices.filter(isPhysicalOffice)
    : [];
  let cptCodePhysicalOffices = officesForCptCode?.length
    ? officesForCptCode.filter(isPhysicalOffice)
    : [];

  if (selectedPhysicalOffices.length) {
    selectedPhysicalOffice = cptCodePhysicalOffices.length
      ? cptCodePhysicalOffices.find(office => selectedPhysicalOffices.includes(office))
      : selectedPhysicalOffices[0];
  } else if (cptCodePhysicalOffices.length) {
    selectedPhysicalOffice = cptCodePhysicalOffices[0];
  } else {
    selectedPhysicalOffice =
      dominantOffice && isPhysicalOffice(dominantOffice) ? dominantOffice : null;
  }

  let left = selectedPhysicalOffice
    ? officeCityStateLine(selectedPhysicalOffice)
    : practiceDefaultCityStateLine(practice);

  let right = modalityLabel({ hasInPerson, hasTelehealth, intl, k });
  return left ? `${left} | ${right}` : right;
}
